import { Component } from '@angular/core';
import { SkipLearningCycleNoteEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Learning Cycle Notes') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-skiplearningcyclenote-form',
    templateUrl: './skiplearningcyclenote.form.component.html'
})
export class SkipLearningCycleNoteFormComponent extends BaseFormComponent {
    public record!: SkipLearningCycleNoteEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

